import { render, staticRenderFns } from "./DataGridMaterialesStock.vue?vue&type=template&id=7c57952a&scoped=true&"
import script from "./DataGridMaterialesStock.vue?vue&type=script&lang=js&"
export * from "./DataGridMaterialesStock.vue?vue&type=script&lang=js&"
import style0 from "./DataGridMaterialesStock.vue?vue&type=style&index=0&id=7c57952a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c57952a",
  null
  
)

export default component.exports